var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeter1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 2500,
    width: 2183,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 124 141.53199999999998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.383 126.894L0 0l124 .255-10.979 126.639-50.553 14.638z",
    fill: "#e9ca32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.468 129.277V12.085l51.064.17-9.106 104.851z",
    fill: "#ffde25"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57 26H43.5v78L33 102V91.5l-12.5-2V113l36.5 9.5zM67.127 26H104.5L102 40.95H81.394v24.533H102L99.5 115l-32.373 7.5V107L89 99.5 90.263 79l-23.136 3.35z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeter1);
export default __webpack_public_path__ + "static/media/meter1.b879f838faf1cb951d1c2230fd933a39.svg";
export { ForwardRef as ReactComponent };